<template>
  <div v-loadcover="applicationsFetchInProgress" class="application-list">
    <div class="row">
      <div class="col-sm-12">
        <table class="table">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Program</th>
              <th class="text-center">
                Status
              </th>
              <th class="text-center">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="application in applications" :key="application.id">
              <td>{{ application.organization.name }}</td>
              <td>{{ application.program.name }}</td>
              <td class="text-center">
                <span
                  v-if="application.state === DRAFT"
                  class="label label-info"
                  >Draft</span
                >
                <el-tooltip
                  :content="submittedAtTooltipLabel(application)"
                  placement="top"
                >
                  <span
                    v-if="application.state === SUBMITTED"
                    class="label label-success"
                    >Submitted</span
                  >
                </el-tooltip>
              </td>
              <td class="flex-center">
                <el-tooltip
                  :content="actionButtonTooltipLabel(application)"
                  placement="top"
                >
                  <router-link
                    class="btn btn-primary btn-xs"
                    :class="{ 'btn-success': application.state === SUBMITTED }"
                    :to="{
                      name: 'dashboardApplicationDetails',
                      params: { id: application.id },
                    }"
                  >
                    <span v-if="application.state === SUBMITTED"
                      ><i class="ion-document-text"
                    /></span>
                    <span v-if="application.state === DRAFT"
                      ><i class="ion-edit"
                    /></span>
                  </router-link>
                </el-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { dateFilter } from '@/filters'

const DRAFT = 'draft'
const SUBMITTED = 'submitted'

export default {
  data: () => ({
    DRAFT,
    SUBMITTED,
    selected: [],
  }),
  async created() {
    await this.$store.dispatch('user/getUser')
    const startupId = this.user.startupId
    await this.$store.dispatch('startupApplications/fetch', { startupId })
    this.setInitialSelection()
  },
  computed: {
    ...mapGetters({
      isSubmitInProgress: 'startupApplications/isSubmitInProgress',
    }),
    ...mapState({
      user: (state) => state.user.data,
      applications: (state) => state.startupApplications.applications,
      applicationsFetchInProgress: (state) =>
        state.startupApplications.fetchInProgress,
    }),
  },
  methods: {
    setInitialSelection() {
      while (this.selected.length) {
        this.selected.pop()
      }

      this.applications.forEach((app) => {
        if (app.state === DRAFT) {
          this.selected.push(app.organization.id)
        }
      })
    },
    async submit({ organizationId }) {
      const startupId = this.user.startupId
      this.$store.dispatch('startupApplications/submit', {
        startupId,
        organizationId,
      })
    },
    isDraft(state) {
      return state === DRAFT
    },
    isSubmitted(state) {
      return state === SUBMITTED
    },
    submittedAtTooltipLabel(application) {
      if (application.submitted_at) {
        return dateFilter(application.submitted_at)
      }
    },
    actionButtonTooltipLabel(application) {
      return application.state === DRAFT ? 'Fill form' : 'Show Form'
    },
  },
}
</script>
<style lang="scss" scoped>
.application-list {
  display: flex;
  justify-content: center;
  margin: 20px 0;

  .btn-success {
    width: 28px;
  }
}

.row {
  width: 100%;
}

tr {
  border-color: #e8e8e9;
}
</style>
